import React from "react";
import { connect } from "react-redux";
import { Grid, Typography } from "material-ui";
import { Link } from "react-router-dom";

import ExtendedField from "../../components/form/ExtendedField";
import renderTextfield from "../../components/form/RenderTextField";
import { ReduxState, ReduxDispatch } from "../../ducks/reducers";
import RegisterPageForm, {
    RegisterFormData,
} from "./components/RegisterPageForm";
import { register } from "../../ducks/user";
import {
    RouterProps,
    RouteProps,
    Redirect,
    RouteComponentProps,
} from "react-router";
import logger from "../../util/logger";
import logo from "../../images/hypo-logo-complete-blue.svg";
import {
    SetHeader,
    ShowBackNavigationWithRoute,
    SetShowBackNavigation,
} from "../../ducks/common";

const styles = {
    flex: {
        flex: 1,
    },
    menuButton: {
        marginLeft: 0,
        marginRight: -12,
    },
};

interface IRegisterPageProps
    extends RouteComponentProps<{ verificationHash: string }> {}
interface IRegisterPageReduxProps {}
interface IRegisterPageDispatchProps {
    register: (
        username: string | null | undefined,
        email: string,
        phoneNumber: string,
        password: string | null | undefined,
        verifyPassword: string | null | undefined,
        verificationHash: string,
        useTupas: boolean
    ) => Promise<void>;
    setHeaderValue: (header: string) => void;

    setBackButton: (route: string) => void;
    hideBackButton: () => void;
}

interface RegisterPageState {
    redirect: boolean;
}

type RegisterPageProps = IRegisterPageProps &
    IRegisterPageReduxProps &
    IRegisterPageDispatchProps &
    RouterProps;

export class RegisterPage extends React.Component<
    RegisterPageProps,
    RegisterPageState
> {
    constructor(props: RegisterPageProps) {
        super(props);
        this.state = { redirect: false };
    }
    componentDidMount() {
        this.props.setBackButton("/login");
        this.props.setHeaderValue("Rekisteröinti");
    }

    componentWillUnmount() {
        this.props.hideBackButton();
        this.props.setHeaderValue("");
    }

    register = async (data: RegisterFormData) => {
        const verificationHash = this.props.match.params.verificationHash; // Get this from route props?
        if (!verificationHash) {
            logger.warn("No verification hash");
            return;
        }
        logger.info(data);
        await this.props
            .register(
                data.username,
                data.email,
                data.phoneNumber,
                data.password,
                data.verifyPassword,
                verificationHash,
                data.useTupas
            )
            .then(() => this.setState({ ...this.state, redirect: true }))
            .catch((err) => logger.error(err));
    };

    render() {
        if (this.state.redirect === true) {
            return <Redirect to="/login" />;
        }
        if (!this.props.match.params.verificationHash) {
            return <Redirect to="/eidentify/" />;
        }
        return (
            <div className="LoginPage_Container container-with-logo">
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                    }}
                >
                    <Grid container spacing={0} justify="center">
                        <Grid item xs={12} sm={10} md={6}>
                            <Typography
                                variant="title"
                                color="inherit"
                                style={styles.flex}
                            >
                                <img
                                    className={"loginLogo"}
                                    src={logo}
                                    alt=""
                                />
                            </Typography>
                            <h1
                                className={"loginHeader"}
                                style={{ color: "#646363" }}
                            >
                                Rekisteröinti
                            </h1>
                            <Typography style={{ marginBottom: 8 }}>
                                Tervetuloa käyttämään Hypon mobiilipankkia.
                                Rekisteröitymisen yhteydessä hyväksyt palvelun
                                käyttöehdot, sekä voit valita, miten haluat
                                jatkossa kirjautua palveluun. Rekisteröitymisen
                                jälkeen kirjaudu sisään luoduilla tunnuksillasi.
                            </Typography>
                            <RegisterPageForm
                                form="register"
                                onSubmit={this.register}
                            />
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ReduxState): IRegisterPageReduxProps => {
    return {};
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IRegisterPageDispatchProps => {
    return {
        register: async (
            username: string,
            email: string,
            phoneNumber: string,
            password: string,
            verifyPassword: string,
            verificationHash: string,
            useTupas: boolean
        ) => {
            logger.info(useTupas);
            await dispatch(
                register(
                    username,
                    email,
                    phoneNumber,
                    password,
                    verifyPassword,
                    verificationHash,
                    useTupas
                )
            );
        },
        setHeaderValue: (header) => {
            return dispatch(SetHeader(header));
        },
        setBackButton: (route: string) => {
            dispatch(ShowBackNavigationWithRoute(route));
        },
        hideBackButton: () => {
            dispatch(SetShowBackNavigation(false));
        },
    };
};

export default connect<
    IRegisterPageReduxProps,
    IRegisterPageDispatchProps,
    IRegisterPageProps
>(
    mapStateToProps,
    mapDispatchToProps
)(RegisterPage);



// WEBPACK FOOTER //
// ./src/views/register/RegisterPage.tsx